module.exports = __webpack_public_path__ + "media/images/global/icons/letter-d76bf54ce167e949b4639e73b5b9d777.svg";